module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/m_all-0a068ee6e2b524b42423c78e6506d895.svg";